module.exports = __webpack_public_path__ + "static/img/open_code1.acc7aca7.jpg";